export const FREE_SHIPPING_THRESHOLD = 396;
export const GREEN_DELIVERY_TRUCK_ICON = 'https://assets.thdstatic.com/images/v1/truck-icon-green.svg';
export const CART_BTN_MESSAGE = 'Add Items to Cart';
export const APPLIANCE_CART_BTN_MESSAGE = 'Add Bundle To Cart';
export const APPLIANCE_BUNDLE_PRICE_MSG = 'Price for Bundle';
